// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipsResultsList from './pips-results-list';

const PipProductsList = props =>
    props.pipProducts.length || props.busyCounter ?
        <PipsResultsList
            pipProducts={props.pipProducts}
        /> :
            <FormattedMessage id='NO_PIP_PRODUCTS'/>;

PipProductsList.displayName = 'PipProductsList';
PipProductsList.propTypes = {
    busyCounter: PropTypes.number.isRequired,
    pipProducts: PropTypes.arrayOf(PropTypes.instanceOf(PipProduct)).isRequired
};

export default PipProductsList;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pips-results-container.js